import { render, staticRenderFns } from "./LoginEnviado.vue?vue&type=template&id=139f85aa&"
import script from "./LoginEnviado.vue?vue&type=script&lang=js&"
export * from "./LoginEnviado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports